module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_orl_5ecb809.ico";